/**
 * Bundle references for development and production environments
 *
 * This file contains only the bundle reference data and can be imported
 * by both the application config and E2E tests without ESM issues.
 */

export const bundleRefs = {
  development: {
    pur: '001PBAFAKAX8ZUUVY2',
    purAndPrint: '001PBX18A2610YG0B0',
    purAndPrintYearly: '001PB6RNRXD3WDMDP2',
    purDaily: '001PB3FKOWUM3CO6L2',
    purForSubscribers: '001PBHLEX42YTF8D31',
    purYearly: '001PB5JXQZ7UTQ2Y60',
    supporterMonthly: '001PBMTARFFD442LG1',
    supporterSingle: '001PB879NLLGY4QMT0',
    supporterYearly: '001PB1L1M6J28YW231',
    smart: '001PB4OKNTOC2VH4H1',
    smartPlusPur: '001PB2M4RILBYA93F2'
  },
  production: {
    pur: '001PBYNHBRKVF1IDV1',
    purAndPrint: '001PBFLO2NYI6ZI7R3',
    purAndPrintYearly: '001PB6A30W69A74UT2',
    purDaily: '001PBQG17NACV41NJ2',
    purForSubscribers: '001PBGY4QRKTGWEAZ0',
    purYearly: '001PBH22FJ3NI3O443',
    supporterSingle: '001PBKIP0MRZ3YPJ80',
    supporterMonthly: '001PBOSKDO7X77G611',
    supporterYearly: '001PBB14NB7VMNQBE2',
    smart: '001PB5WJ7BDIF9D1Q1',
    smartPlusPur: '001PB93O9RBUPT8X10'
  }
} as const;

export type Environment = keyof typeof bundleRefs;
export type BundleRefKey = keyof typeof bundleRefs.development;
